import { getClientHost } from '../helpers/client';
import { getOrCreateEncodedUUID } from '../helpers/user-meta';
import { getLanguageAndQueryParams } from '../helpers/language';

const userId = getOrCreateEncodedUUID();

/**
 * GET /score-predictor/{prediction_id}
 * Fetches Playbook Prediction data from Fan API
 *
 * @param {string} predictionId - Playbook Score Predictor predictionId
 * @param {boolean} isGated - is the score predictor gated
 * @param {string} authHeader - Authorization header for gated score predictors
 * @returns {Promise} -
 */
export const getScorePredictorData = (predictionId, isGated, authHeader) => {
    const { queryParams } = getLanguageAndQueryParams();

    const SCORE_PREDICTOR_HOST = `${getClientHost()}${
        process.env.API_PATH_SCORE_PREDICTOR
    }`;

    const endpoint = isGated
        ? `https://${SCORE_PREDICTOR_HOST}/gated/score-predictor/${predictionId}${queryParams}`
        : `https://${SCORE_PREDICTOR_HOST}/score-predictor/${predictionId}${queryParams}`;

    const headers = {
        'Content-Type': 'application/json',
        ...(!isGated && { 'X-User-Id': userId })
    };

    if (isGated && authHeader) {
        headers.Authorization = authHeader;
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            headers
        })
            .then((response) => {
                if (!response.ok) {
                    console.warn(
                        'Playbook - Score predictor embed unsuccessful',
                        predictionId
                    );
                    return null;
                }

                return response.json();
            })
            .then((predictionData) => {
                resolve(predictionData);
            })
            .catch((error) => {
                console.error(
                    'Playbook - Score predictor embed unsuccessful',
                    error
                );
                reject(error);
            });
    });
};

/**
 * POST /score-predictor/{prediction_id}/answers
 * Submit an answer to a score-predictor
 *
 * @param {string} predictionId - score predictor ID
 * @param {string} payload - answer
 * @param {string} isGated - should it be gated
 * @param {string} authHeader - auth header
 * @returns {Promise} -
 */
export const sendAnswer = (predictionId, payload, isGated, authHeader) => {
    const PREDICTIONS_HOST = `${getClientHost()}${
        process.env.API_PATH_SCORE_PREDICTOR
    }`;

    const endpoint = isGated
        ? `https://${PREDICTIONS_HOST}/gated/score-predictor/${predictionId}/answers`
        : `https://${PREDICTIONS_HOST}/score-predictor/${predictionId}/answers`;

    const headers = {
        'Content-Type': 'application/json',
        ...(!isGated && { 'X-User-Id': userId })
    };

    if (isGated && authHeader) {
        headers.Authorization = authHeader;
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (
                    response.status &&
                    !response.status.toString().match(/2\d{2}/g)
                ) {
                    // Non sucessful response
                    reject(response);
                    return;
                }
                resolve(response);
            })
            .catch((error) => {
                console.error(
                    'Playbook - Score predictor submission answer unsuccessful.',
                    error
                );
                reject(error);
            });
    });
};
